// extracted by mini-css-extract-plugin
module.exports = {"primary":"button-module--primary--c4XPI","secondary":"button-module--secondary--31pqM","tertiary":"button-module--tertiary--36i39","disabled":"button-module--disabled--wMoZj"};